import * as yup from 'yup'

export const schemaUser = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  phone: yup.string().phone({ required: true }),
})

export default schemaUser
